import { useState,useEffect } from 'react';
import ProposalService from '../../../services/ProposalService';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import Modal from '../../Modal';
import { useNavigate } from 'react-router-dom';

interface IProp {
  proposal: any;
  statusActual: any;
}
const Action9 = ({ proposal, statusActual }: IProp) => {
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const [showConfirmSchedule, setShowConfirmSchedule] = useState<boolean>(false);
  const [showDateApresentation, setShowDateApresentation] = useState<boolean>(false);
  const [dateHora, setDataHora] = useState<string>('');
  const navigate = useNavigate();
  useEffect(() => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60000)
      .toISOString()
      .slice(0, 16);

    setDataHora(localDate);
  }, []);

  const SendNegociation = ()=>{
    setIsLoad(true);
    new ProposalService().UpdateProposalStatusNegociation(proposal.id)
          .then((response: any) => {
            if (response) {
              navigate(0)
            } else {
              setIsLoad(false);
            }
          })
          .catch((error: any) => {
            Modal.show({
              title: "Erro ao salvar pendings",
              body: Modal.getErrorMessage(error, {"proposalId":proposal.id} ),
              showCancel: true,
              showConfirm: false,
              onCancelText: "Fechar"
            });
            setIsLoad(false);
          });
  }
  const SendDateApresentation = ()=>{
    setIsLoad(true);
    new ProposalService().UpdateDataHoraAgendarProposal({ "Id": proposal.id,  "Date":dateHora})
          .then((response: any) => {
            if (response) {
              navigate(0)
            } else {
              setIsLoad(false);
            }
          })
          .catch((error: any) => {
            Modal.show({
              title: "Erro ao salvar pendings",
              body: Modal.getErrorMessage(error, {"dateHora":dateHora} ),
              showCancel: true,
              showConfirm: false,
              onCancelText: "Fechar"
            });
            setIsLoad(false);
          });
  }
  return (
    <>
      {
        isLoad &&
        <LoadingSpinner />
      }
      {
        (proposal.idProposalType === 5 && statusActual.idProposalStatus === 34) ?
          <>
            <button className='btn btn-primary btnForm minWidth200' onClick={() => {setShowConfirmSchedule(true)}}>Agendar apresentação comercial</button>
            {showConfirmSchedule && (
                    <div style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 999
                    }}>
                        
                        <div style={{
                        background: "#fff",
                        padding: 20,
                        borderRadius: 8,
                        width: 450,
                        textAlign:'center'
                        }}>
                          {
                            (showDateApresentation) ?
                              <>
                                <h5>Informe a data e hora disponivel</h5>
                                <input
                                  type="datetime-local"
                                  value={dateHora}
                                  onChange={(e) => setDataHora(e.target.value)}
                                  style={{
                                    padding: 8,
                                    width:'100%',
                                    fontSize: 16,
                                    marginTop: 10,
                                    marginBottom:10
                                  }}
                                />
                                <button className='btn btn-success' style={{maxWidth:100, marginRight:10}} onClick={() => {SendDateApresentation()}}>Salvar</button>
                                <button className='btn btn-danger' style={{maxWidth:100}} onClick={() => {setShowDateApresentation(false);setShowConfirmSchedule(true); }}>Cancelar</button>
                              </>
                            :
                            <>
                              <h5>Deseja agendar a apresentação comercial?</h5>
                              <div style={{ display: "flex",  gap: 10 }}>
                                <button className='btn btn-primary btnForm minWidth200' onClick={() => {setShowDateApresentation(true)}}>SIM</button>
                                <button className='btn btn-info minWidth200' onClick={() => {SendNegociation()}}>NÃO</button>
                              </div>
                              <div style={{marginTop:15,textAlign:'left'}}>
                                <p style={{margin:0,padding:0,fontSize:10}}>* Sim = Você irá preencher a data e hora possivel para agendar a apresentação;</p>
                                <p style={{margin:0,padding:0,fontSize:10}}>* Não = A proposta irá direto para a negociação;</p>
                              </div>
                              <div style={{marginTop:15,textAlign:'right'}}>
                                <button className='btn btn-danger' style={{maxWidth:100}} onClick={() => {setShowDateApresentation(false);setShowConfirmSchedule(false); }}>Cancelar</button>
                              </div>
                            </>
                          }
                          
                        </div>
                    </div>
            )}
            <Modal/>
          </>
          : <></>
      }

    </>
  )
};

export default Action9;
